import React from 'react';
import alma from '../../assets/img/tgle-alma-dark.png';


const  Alma = ()=>{
    return <div style={{ textAlign:'center', paddingTop:'50px' }}><img alt='logo' src={alma } style={{maxWidth:'80%', maxHeight:'180px'}} /></div>;
};

export default Alma;
